import { render, staticRenderFns } from "./buyerBenefitCard.vue?vue&type=template&id=4d814344&"
import script from "./buyerBenefitCard.vue?vue&type=script&lang=js&"
export * from "./buyerBenefitCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports